export default function ProvablySeedPair(obj: any) {
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256,
  } = obj

  const CurrentSeedPair = [
    {
      title: 'Client seed',
      content: client_seed ? client_seed : '-',
      enableCopy: client_seed ? true : false,
    },
    {
      title: 'Server seed hash',
      content: server_seed_SHA256 ? server_seed_SHA256 : '-',
      enableCopy: server_seed_SHA256 ? true : false,
    },
    {
      title: 'Nonce',
      content: nonce ? nonce : 0,
      enableCopy: nonce > 0 ? true : false,
    },
    {
      title: 'Next server seed hash',
      content: next_server_seed_SHA256 ? next_server_seed_SHA256 : '-',
      enableCopy: next_server_seed_SHA256 ? true : false,
    },
  ]
  const PreviousSeedPair = [
    {
      title: 'Client seed',
      content: old_client_seed ? old_client_seed : '-',
      enableCopy: old_client_seed ? true : false,
    },
    {
      title: 'Server seed',
      content: old_server_seed ? old_server_seed : '-',
      enableCopy: old_server_seed ? true : false,
    },
    {
      title: 'Server seed hash',
      content: old_server_seed_SHA256 ? old_server_seed_SHA256 : '-',
      enableCopy: old_server_seed_SHA256 ? true : false,
    },
    {
      title: 'Nonce',
      content: old_nonce ? old_nonce : 0,
      enableCopy: old_nonce > 0 ? true : false,
    },
  ]
  return { CurrentSeedPair, PreviousSeedPair }
}
